<template>
  <div class="modal-mask">
    <div class="card">
      <label class="title">{{
        isEdit ? "Edit Package" : "Create New Package"
      }}</label>
      <label class="description"
        >Please select a file , enter a name , price of the package and tests
        included in the package</label
      >

      <form class="form">
        <div class="form-group">
          <label class="ionput-label">Name</label>
          <input
            class="form-control"
            placeholder="Enter a name for the package"
            v-model="name"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Price</label>
          <input
            class="form-control"
            placeholder="Enter a price for the package"
            v-model="price"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Category</label>
          <input
            class="form-control"
            placeholder="Enter the category for the test"
            v-model="category"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Tests</label>
          <input
            class="form-control"
            placeholder="Enter tests name like test1 , test2 , test3"
            v-model="tests"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Cover Image</label>
          <input
            class="form-control"
            type="file"
            @change="previewFiles"
            ref="myFiles"
          />
        </div>

        <div class="preview-container" v-if="localImgUrl">
          <label class="ionput-label">Preview (16:9 Aspect Ratio)</label>
          <img class="preview" :src="localImgUrl" alt="" />
        </div>
      </form>

      <div class="actions">
        <button
          class="btn btn-outline-primary w-100 font-weight-bold"
          @click="cancel"
        >
          Cancel
        </button>
        <button class="btn btn-primary w-100 font-weight-bold" @click="save">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP, URLS } from "../network/http";
let NotificationsController = require("./NotificationsController");

export default {
  name: "DeleteItemModel",
  props: ["editModel"],
  data() {
    return {
      name: "",
      price: "",
      tests: "",
      category: "",
      files: [],
      localImgUrl: null,
      isEdit: false,
    };
  },
  methods: {
    previewFiles() {
      this.files = this.$refs.myFiles.files;
      this.localImgUrl = URL.createObjectURL(this.files[0]);
    },
    uploadCoverImage() {
      return new Promise((resolve, reject) => {
        if (this.isEdit && this.files.length <= 0) {
          resolve({
            ok: true,
            content: this.editModel.cover_url,
          });
          return;
        }

        if (!this.files || !this.files[0]) {
          resolve({
            ok: false,
            content: "Please select an image",
          });
          return;
        }

        NotificationsController.showActivityIndicator();
        var formData = new FormData();
        formData.append("file", this.files[0]);
        formData.append("folder", "packages");
        HTTP.post(URLS.FILES.UPLOAD, formData)
          .then((response) => {
            // let cover_url = response.data.url;
            resolve({
              ok: true,
              content: response.data.url,
            });
          })
          .catch((err) => {
            var msg = "";
            try {
              msg = err.response.data.message;
            } catch (error) {
              msg = err.message;
            }
            NotificationsController.hideActivityIndicator();
            resolve({
              ok: false,
              content: msg,
            });
          });
      });
    },
    async save() {
      if (!this.name || this.name == "") {
        this.$toast.error("Please enter a package name");
        return;
      }

      if (!this.price || this.price == "") {
        this.$toast.error("Please enter price for the package");
        return;
      }

      if (!this.category || this.category == "") {
        this.$toast.error("Please enter category for the package");
        return;
      }

      if (!this.tests || this.tests == "") {
        this.$toast.error("Please enter atleast one test for the package");
        return;
      }

      const { ok, content } = await this.uploadCoverImage();
      if (!ok) {
        this.$toast.error(content);
        return;
      }

      let tests = this.tests.split(",");
      let cleanTests = tests.filter(function (e) {
        if (!e || e == "" || e == " " || e == undefined || e == null) {
          return false;
        }
        return true;
      });

      let data = {
        name: this.name,
        price: this.price || "",
        cover_url: content,
        tests: cleanTests,
        category: this.category,
      };

      if (!this.isEdit) {
        HTTP.post(URLS.PACKAGE.CREATE, data)
          .then((res) => {
            this.$toast.success(res.data.message);
            NotificationsController.hideActivityIndicator();
            this.$emit("success", res.data);
          })
          .catch((err) => {
            var msg = "";
            try {
              msg = err.response.data.message;
            } catch (error) {
              msg = err.message;
            }
            this.$toast.error(msg);
            this.$emit("fail", err.response);
            NotificationsController.hideActivityIndicator();
          });
      } else {
        HTTP.patch(URLS.PACKAGE.BY_ID.replace(":id", this.editModel.id), data)
          .then((res) => {
            this.$toast.success(res.data.message);
            NotificationsController.hideActivityIndicator();
            this.$emit("success", res.data);
          })
          .catch((err) => {
            var msg = "";
            try {
              msg = err.response.data.message;
            } catch (error) {
              msg = err.message;
            }
            this.$toast.error(msg);
            this.$emit("fail", err.response);
            NotificationsController.hideActivityIndicator();
          });
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  created() {
    this.isEdit = this.editModel != null;
    if (this.isEdit) {
      this.localImgUrl = this.editModel.cover_url;
      this.name = this.editModel.name;
      this.price = this.editModel.price;
      this.category = this.editModel.category;
      this.tests = this.editModel.tests.toString();
    }
  },
  mounted() {},
};
</script>

<style lang="scss">
.preview-container {
  display: flex;
  flex-direction: column;

  .preview {
    width: 16rem !important;
    height: 9rem !important;
  }
}
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    width: 50%;
    max-height: 80%;
    background-color: white;
    border-radius: 4px;
    padding: 20px;

    .title {
      width: 100%;
      line-height: 50px;
      font-size: 20px;
      color: black;
    }

    .description {
      width: 100%;
      font-size: 16px;
      text-align: left;
      color: gray;
      margin-top: -20px;
      margin-bottom: 1rem;
    }

    .form {
      max-height: calc(100% - 200px);
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
    }

    .actions {
      height: 50px;
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: 20px;
    }
  }
}
</style>
